<template>
  <i-select :value="value" :multiple="multiple" v-on="$listeners" @input="on_select">
    <i-option v-if="general" value="all" :label="$t('voice.trunk.type.all')" />

    <i-option-group :label="$t('voice.trunk.type.incoming')">
      <i-option v-for="t in trunks_incoming" :key="t.id" :value="t.id" :label="t.name" />
    </i-option-group>

    <i-option-group :label="$t('voice.trunk.type.outgoing')">
      <i-option v-for="t in trunks_outgoing" :key="t.id" :value="t.id" :label="t.name" />
    </i-option-group>
  </i-select>
</template>

<script>
  export default {
    props: {
      value: {
        type: [Number, String],
        default: null
      },
      trunks: {
        type: [Array],
        default: () => []
      },
      general: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      trunks_incoming: function () {
        return this.trunks.filter((f) => f.type === 'incoming');
      },

      trunks_outgoing: function () {
        return this.trunks.filter((f) => f.type === 'outgoing');
      }
    },
    methods: {
      on_select: function(value = null) {
        this.$emit('input', value);
      }
    }
  };
</script>
